const escapeHtml = value => String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

const normalizeFileName = value => String(value || 'report')
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    || 'report'

const renderHeaderCellPair = item => {
    if (!item) return '<td></td><td></td>'
    const value = item.value === null || item.value === undefined ? '' : item.value
    return `<td class="parameter-label">${escapeHtml(item.label || '')}</td><td>${escapeHtml(value)}</td>`
}

const exportTableToExcel = ({
    title,
    fileName,
    companyName,
    companyAddress,
    reportParameters = [],
    reportParametersRight = [],
    generatedBy,
    executionDateTime,
    columns,
    items,
    getCellValue,
    isSummaryRow = item => item && item.summaryRow,
}) => {
    const safeTitle = escapeHtml(title || 'Report')
    const maxParameterRows = Math.max(reportParameters.length, reportParametersRight.length)
    const parameterRowIndexes = [...Array(maxParameterRows).keys()]
    const parameterRows = parameterRowIndexes.map(index => {
        const leftItem = reportParameters[index]
        const rightItem = reportParametersRight[index]
        return `<tr>${renderHeaderCellPair(leftItem)}${renderHeaderCellPair(rightItem)}</tr>`
    }).join('')
    const generatedInfoRow = generatedBy || executionDateTime
        ? `<tr>${renderHeaderCellPair({ label: 'Generated By', value: generatedBy })}${renderHeaderCellPair({ label: 'Execution Date', value: executionDateTime })}</tr>`
        : ''
    const headerCells = columns.map(column => `<th>${escapeHtml(column.label || column.key)}</th>`).join('')
    const bodyRows = items.map(item => {
        const cells = columns.map(column => {
            const rawValue = getCellValue ? getCellValue(item, column) : item[column.key]
            const value = rawValue === null || rawValue === undefined ? '' : rawValue
            return `<td>${escapeHtml(value)}</td>`
        }).join('')
        const rowStyle = isSummaryRow(item) ? ' style="font-weight:bold;background-color:#f3f2f7;"' : ''
        return `<tr${rowStyle}>${cells}</tr>`
    }).join('')

    const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <style>
    body { font-family: Arial, sans-serif; }
    table { border-collapse: collapse; }
    th, td { border: 1px solid #d8d6de; padding: 4px 6px; mso-number-format:"\\@"; }
    th { font-weight: bold; background-color: #f3f2f7; }
    .company-name { font-size: 18px; font-weight: bold; border: none; }
    .company-address { border: none; color: #555555; }
    .report-title { font-size: 16px; font-weight: bold; border: none; padding-top: 10px; }
    .header-spacer td { border: none; height: 8px; }
    .parameter-label { font-weight: bold; background-color: #f3f2f7; }
  </style>
</head>
<body>
  <table>
    <tr><td class="company-name" colspan="4">${escapeHtml(companyName || '')}</td></tr>
    <tr><td class="company-address" colspan="4">${escapeHtml(companyAddress || '')}</td></tr>
    <tr><td class="report-title" colspan="4">${safeTitle}</td></tr>
    ${parameterRows}
    ${generatedInfoRow}
    <tr class="header-spacer"><td colspan="4"></td></tr>
  </table>
  <table>
    <thead><tr>${headerCells}</tr></thead>
    <tbody>${bodyRows}</tbody>
  </table>
</body>
</html>`

    const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${normalizeFileName(fileName || title)}.xls`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}

export default exportTableToExcel
